<template lang="pug">
	div.reproductor(:class="(idObjeto) ? 'show' : ''")
		audio(
			ref="player",
			autoplay="true",
			:src="'/src/modulos/organizar-emisoras/php/api/reproducir.php?ObjetoID=' + idObjeto",
			type="audio/mpeg",
			style="position:relative;display:inline-block;vertical-align:middle;width: calc(100% - 80px);"
		)
		div.player
			div.duracion
				div(v-if="actual && duracion")
					span {{Math.round(actual)}}
					| /
					span {{Math.round(duracion)}}
			div.barra(ref="barra")
				div.progreso(:style="estiloBarra")
			div.boton
				button.btn.btn-danger(@click="cerrar", style="border-radius: 0;")
					span.fa.fa-close.mr-2
					| Cerrar
</template>

<script>
export default {
	props: ['idObjeto'],
	data () {
		return {
			estiloBarra: {
				width: 0
			},
			actual: 0,
			duracion: 0
		}
	},
	watch: {
		idObjeto: function (newVal, oldVal, next) {
			if (newVal) {
				this.$refs.player.play()
			}
		}
	},
	mounted () {
		this.$refs.player.addEventListener('ended', this.cerrar)
		this.$refs.player.addEventListener('timeupdate', this.progreso)
		this.$refs.player.addEventListener('durationchange', this.cambiaDuracion)
		this.$refs.barra.addEventListener('click', this.click)
	},
	beforeDestroy () {
		this.$refs.player.removeEventListener('ended', this.cerrar)
		this.$refs.player.removeEventListener('timeupdate', this.progreso)
		this.$refs.player.removeEventListener('durationchange', this.cambiaDuracion)
		this.$refs.barra.removeEventListener('click', this.click)
	},
	methods: {
		click (e) {
			console.log(e.offsetX)
			const porcentaje = e.offsetX * 100 / this.$refs.barra.offsetWidth
			const tiempo = Math.round(this.duracion * porcentaje / 100)
			this.$refs.player.currentTime = tiempo
		},
		cambiaDuracion (e) {
			console.log(e)
			console.log('Duracion: ' + this.$refs.player.duration)
		},
		progreso (e) {
			// console.log(e)
			this.actual = this.$refs.player.currentTime
			this.duracion = this.$refs.player.duration
			const percent = this.actual * 100 / this.duracion
			this.estiloBarra = {
				width: percent + '%'
			}
		},
		cerrar () {
			this.$refs.player.pause()
			this.$emit('cerrar')
		}
	}
}
</script>
<style scoped>
	.reproductor {
		position: fixed;
		display: block;
		height: 30px;
		bottom: 0px;
		left: 0;
		right: 0;
		background-color: rgba(255, 255, 255, 0.7);
		transform: translateY(40px);
		transition: transform 500ms ease-in-out;
		box-shadow: 0 -8px 10px rgba(0, 0, 0, 0.2);
	}

	.reproductor.show {
		transform: translateY(0);
	}

	.player {
		position: relative;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-content: stretch;
		align-items: stretch;
		height: 30px;
		background-color: #222222;
	}

	.duracion {
		min-width:60px;
		max-width: 60px;
		text-align: center;
		vertical-align: middle;
		align-content: center;
		align-self: center;
		color: white;
	}

	.barra {
		position: relative;
		flex: 1 1;
		font-size: 1em;
	}

	.barra > .progreso {
		position: absolute;
		display: block;
		left: 0;
		top: 0;
		bottom: 0;
		width: 0;
		background-color: #e0e0e0;
		transition: width 200ms linear;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/organizar-emisoras/vue/componentes/reproductor.vue